<template>
<div>
    <v-container class="px-0">
        <v-col cols="12">
            <v-row>
                <v-col cols="12" lg="6" md="6">
                    <high-charts-pie 
                        :id="1" 
                        :items="itemsLot"
                        :visibleSubTitle="true"
                        :subtitle="'LOTES VENDIDOS POR AÑO'"
                    />
                </v-col>
                <v-col cols="12" lg="6" md="6">
                   <high-charts-pie 
                        :id="2" 
                        :items="itemsArea"
                        :visibleSubTitle="true"
                        :subtitle="'M2 VENDIDOS POR AÑO'"
                        :valueSuffix="'M2'"
                    />
                </v-col>
                <v-col cols="12" lg="12" md="12" class="mt-3">
                    <high-charts-pie 
                        :id="3" 
                        :items="itemsCapital"
                        :visibleSubTitle="true"
                        :subtitle="'TOTAL CAPITAL POR AÑO'"
                        :valueSuffix="'USD'"
                    />
                </v-col>
            </v-row>
        </v-col>
    </v-container>
</div>
</template>

<script>
import HighChartsPie from '../../../components/Utils/HighCharts/HighChartsPie.vue';
export default {
    props: {
        itemsLot: {
            type: Array,
            default: []
        },
        itemsArea: {
            type: Array,
            default: []
        },
        itemsCapital: {
            type: Array,
            default: []
        },
    },
    components: {
        HighChartsPie
    },
    data() {
        return {

        };
    },
    methods: {},
};
</script>

<style>
.tran {
    opacity: 0.7 !important;
}
</style>
